type THeaderLabelProps = {
  children: string
  id?: string
} & Partial<React.HTMLAttributes<HTMLSpanElement>>

export function ModalTitle({ children, id, ...rest }: THeaderLabelProps) {
  return (
    <span
      {...rest}
      data-testid={id}
      className="line-clamp-1 font-bold font-rdmodern text-sixpulse text-text-neutral leading-tiny tracking-tiny"
    >
      {children}
    </span>
  )
}
